export enum Route {
  Home = 'home',
  Login = 'login',
  Logout = 'logout',
  Registration = 'registration',
  Invitation = 'invitation',
  OnboardingWizard = 'onboarding-wizard',
  Maintenance = 'maintenance',
  LimitedApp = 'limited-app',
  UnrecoverableError = 'unrecoverable-error',
  Developer = 'developer',
  MyPlanning = 'my-planning',
  MyProfile = 'my-profile',
  Personal = 'personal',
  Company = 'company',
  Address = 'address',
  BigNumber = 'big-number',
  Financial = 'financial',
  EmergencyContact = 'emergency-contact',
  AccountSettings = 'account-settings',
  Email = 'email',
  PhoneNumber = 'phone-number',
  Password = 'password',
  AppLanguage = 'app-language',
  PushNotification = 'push-notification',
  MyCareer = 'my-career',
  DesiredFunctions = 'desired-functions',
  DesiredLocations = 'desired-locations',
  Educations = 'educations',
  WorkExperiences = 'work-experiences',
  ProfileWizard = 'profile-wizard',
  Category = 'category',
  Documents = 'documents',
  Upload = 'upload',
  NationalId = 'national-id',
  DriversLicense = 'drivers-license',
  BankCard = 'bank-card',
  MyWork = 'my-work',
  Requests = 'requests',
  Holidays = 'holidays',
  TimeRegistration = 'time-registration',
  Balance = 'balance',
  Expenses = 'expenses',
  MyHousing = 'my-housing',
  MyInbox = 'my-inbox',
  Jobs = 'jobs',
  Search = 'search',
  Result = 'result',
  Saved = 'saved',
  Applied = 'applied',
  EventCalendar = 'event-calendar',
  Add = 'add',
  Approve = 'approve',
  Sign = 'sign',
  Start = 'start',
  Finished = 'finished',
  Public = 'public',
  RegistrationError = 'registration-error',
  ShareData = 'share-data',
  Consent = 'consent',
  Name = 'name',
  Phone = 'phone',
  LinkEmail = 'link-email',
  LinkPhone = 'link-phone',
  Chat = 'chat',
  DocumentSelector = 'document-selector',
  Signature = 'signature',
  WorkLocation = 'work-location',
  Customer = 'customer',
  Overview = 'overview',
  ShiftSettings = 'shift-settings',
  Impersonation = 'impersonation',
  PrivacyPolicies = 'privacy-policies',
  Settings = 'settings',
  Loading = 'loading',
  IdentificationDocumentUpload = 'identification-document-upload',
  Screening = 'screening',
  Schedule = 'schedule',
  Shifts = 'shifts',
  Appointment = 'appointment',
  Engagements = 'engagements',
  SuggestedEvents = 'suggested-events',
  Dashboard = 'dashboard',
  Loyalty = 'loyalty',
  About = 'about',
  Tasks = 'tasks',
  Article = 'article',
  Journey = 'journey',
  Knowledge = 'knowledge',
}
